import { TApiSaleTest } from '../../../services/sale/types'
import { ISaleTest } from '../../types'

export function parseTest({ result, user }: TApiSaleTest): ISaleTest {
    return {
        result,
        userId: user
    }
}